export default __webpack_public_path__ + "static/media/visa.558494e5.svg";